import { render, staticRenderFns } from "./StudentTableView.vue?vue&type=template&id=63bb6fb0"
import script from "./StudentTableView.vue?vue&type=script&lang=js"
export * from "./StudentTableView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports